import { useTranslation } from "react-i18next";
import { LOCALES, type Locale } from "../../../contract/auth";
import { setLocale } from "../../i18n";
import { SegmentedControl } from "../control/SegmentedControl";

/** DE|EN. Writes the b2a_lang cookie for one year and switches i18next in place. */
export function LanguageSwitcher() {
  const { t, i18n } = useTranslation("common");
  const current = (i18n.resolvedLanguage ?? i18n.language) as Locale;
  const label: Record<Locale, string> = { de: t("languageDe"), en: t("languageEn") };
  return (
    <SegmentedControl
      label={t("language")}
      value={current}
      onChange={(locale) => void setLocale(locale)}
      options={LOCALES.map((locale) => ({ value: locale, label: label[locale], lang: locale }))}
    />
  );
}
